<template>
    <div class="search_prolist">
        <div class="search_prolist_item">
            <div class="search_prolist_item_inner">
                <div class="search_prolist_cover">
                    <img class="photo" :src="item.cover_url">
                </div>
                <div class="search_prolist_info">
                    <div class="search_prolist_info flex">
                        <div id="pro_info_above">
                            <div class="search_prolist_title" data-line="2">{{ item.name }}</div>
                            <div class="search_prolist_attr">{{ item.tag }}</div>
                        </div>
                        <div id="pro_info_below">
                            <div class="search_prolist_price">¥ {{ item.price }}</div>
                            <div class="search_prolist_other text_small">
                                <span class="search_prolist_comment">评分 {{ item.rate }}</span>
                                <span class="search_prolist_rate">点赞数 {{ item.star }}</span>
                            </div>
                            <div class="search_prolist_shop" nowxa="1">
                                <div class="shop_area"><span class="shop_name">{{ item.business_name }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-cell-group>
            <van-cell title="可用积分" :value="point"/>
            <van-cell title="选择取餐时间" :value="date" @click="showDate=true" required/>
            <van-calendar v-model="showDate" @confirm="onConfirm"/>
            <van-field readonly clickable name="business" :value="business" label="取餐点" placeholder="点击选择取餐点" @click="show_business=true" required/>
            <van-popup v-model="show_business" position="bottom">
                <van-picker show-toolbar :columns="business_list" @confirm="onBusinessConfirm" @cancel="show_business=false"/>
            </van-popup>
        </van-cell-group>
        <van-submit-bar :price="0" button-text="提交订单" @submit="onSubmit">
        </van-submit-bar>
    </div>
</template>
<script>
    import common from "../common";
    import { Dialog } from 'vant';

    export default {
        data() {
            return {
                point: 0,
                item: "",
                product_id: "",
                token: "",
                date: '',
                showDate: false,
                business: '',
                business_list: ["芦潮港同汇路", "九极暂落", "外六"],
                show_business: false,
            };
        },
        methods: {
            onBusinessConfirm(value, index) {
                this.business = value;
                this.show_business = false;
            },
            onConfirm(date) {
                this.showDate = false;
                this.date = `${date.getMonth() + 1}月${date.getDate()}日`;
            },
            onChange(index) {
                this.showList = false;
                if (index >= 0) {
                    this.chosenCoupon = index;
                    var box = document.getElementsByClassName("van-submit-bar__price van-submit-bar__price--integer");
                    if ((this.item.price - this.coupons[index].amount) < 0)
                        box[0].innerText = 0;
                    else
                        box[0].innerText = parseInt(this.item.price - this.coupons[index].amount);
                }
            },
            onSubmit() {
                let querystring = require("querystring");
                let token = this.token;
                this.$api.post("wx/service/orderPay",
                    querystring.stringify({
                        product_id: this.product_id,
                        date: this.date,
                        business: this.business,
                        token: token,
                    })
                ).then(({data}) => {
                    console.log(data);
                    if (data.status == 1) {
                        Dialog.alert({
                            message: '购买成功',
                        }).then(() => {
                            this.$router.push({path: "/order/list/"});
                        });
                    } else {
                        Dialog.alert({
                            message: data.data.msg,
                        }).then(() => {
                        });
                    }
                });
            },
            getProductDetail(id) {
                let querystring = require("querystring");
                let token = this.token;
                this.$api.post("wx/service/productDetail",
                    querystring.stringify({
                        id: this.product_id,
                        token: token,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        this.item = data.data[0];
                        var box = document.getElementsByClassName("van-submit-bar__price van-submit-bar__price--integer");
                        box[0].innerText = parseInt(this.item.price);
                    } else {

                    }
                });
            },
            getWallet() {
                let querystring = require('querystring');
                this.$api.post("/wx/user/wallet",
                    querystring.stringify({
                        mobile: localStorage.getItem("tel"),
                        token: this.token,
                    })
                ).then(data => {
                    if (data.data.status == 1) {
                        this.point = data.data.data.point_balance;
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
        },
        mounted() {
            this.product_id = JSON.parse(this.$router.currentRoute.params.id).id;
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
            this.getProductDetail(this.product_id);
            this.getWallet();
        }
    };
</script>
<style scoped>
    .search_prolist .search_prolist_item_inner {
        position: relative;
        padding-left: 120px;
    }

    .search_prolist .search_prolist_item {
        display: block;
        position: relative;
        padding: 5px 0 5px 10px;
        background-color: #fff;
    }

    .search_prolist .search_prolist_cover {
        position: absolute;
        left: 0;
        top: 0;
        width: 120px;
        height: 120px;
        overflow: hidden;
        background-size: 75px auto;
    }

    .search_prolist .search_prolist_cover .photo {
        width: 120px;
    }

    .search_prolist .search_prolist_info {
        margin: 0 auto;
        min-height: 120px;
        padding-bottom: 8px;
        box-sizing: border-box;
        padding: 0 10px;
        overflow: hidden;
        line-height: 1;
    }

    .search_prolist .search_prolist_title {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 25px;
        word-break: break-all;
        margin-top: 8px;
        color: #333;
        line-height: 1.36;
        font-size: .45rem;
    }

    .search_prolist .search_prolist_attr {
        text-align: left;
        margin: 3px 0 1px;
        height: 15px;
        overflow: hidden;
        font-size: .35rem;
    }

    .search_prolist .search_prolist_price {
        text-align: right;
        display: inline-block;
        margin: 3px 0 3px 0;
        height: 25px;
        color: #e4393c;
        min-width: 100%;
        font-size: .45rem;
    }

    .search_prolist .search_prolist_other {
        text-align: left;
        font-size: .35rem;
        height: 20px;
        padding: 5px 0;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 1.2;
    }

    .search_prolist .search_prolist_shop {
        text-align: left;
        box-sizing: border-box;
        padding-top: 5px;
        height: 5vh;
        color: #999;
        font-size: .35rem;
        overflow: hidden;
    }

    .search_prolist .van-cell {
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/productPay.vue